import type { AxiosError } from 'axios'
import { getErrorText } from 'v2/shared/utils/api-error-text'

// Maps a failed login mutation (or an SSO error string) to the text shown in
// the login screen's alert; timeouts and network failures get friendlier copy.
export const getLoginErrorText = (error: AxiosError | null, ssoError: string | null) => {
  let errText = ''
  if (error) {
    errText = getErrorText(error)
    if (errText.toLowerCase().includes('timeout')) {
      errText = 'Something went wrong. Please try again.'
    }
    if (errText.toLowerCase().includes('network error')) {
      errText = 'Unable to connect. Please check your internet connection and try again.'
    }
  } else if (ssoError) {
    errText = ssoError
  }
  return errText
}
